import styled, { css } from 'styled-components'

import { minmedia } from '../../../styles/media-queries'
import { bottombar, bottombarOverlay } from '../../../styles/z-index'
import { white, bordergray, lightergray } from '../../../styles/colors'

import { BottomBarDropDown } from '../../../styles/defaults-header'

export const Wrap = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: ${white};
  border-top: 1px solid ${bordergray};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  z-index: ${bottombar};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${minmedia.xmlarge`
    display: none;
  `};
`

export const Item = styled.div`
  width: 25%;
  display: flex;
  flex-wrap: wrap;
  background: ${white};

  &:first-child {
    border-right: 1px solid ${lightergray};
  }
  &:last-child {
    border-left: 1px solid ${lightergray};
  }

  ${props =>
    props.active &&
    css`
      background: ${lightergray};

      ${BottomBarDropDown} {
        transform: translateY(0);
        opacity: 1;
      }
    `} a {
    display: block;
    width: 100%;
  }
`

export const IconContainer = styled.div`
  width: 100%;
  padding: 0.5rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: relative;

  svg {
    width: 2.5rem;
    height: 2.5rem;
  }
`

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: ${bottombarOverlay};
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
`



// WEBPACK FOOTER //
// ./src/components/MobileHeader/BottomBar/styles.js